import React, { useState } from "react";
import { collection, getDocs, query } from "firebase/firestore";
import db from "../../utils/firebase.config";

const ConfirmadosPage = () => {
  const [rows, setRows] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const fetchConfirmados = async () => {
    setLoading(true);
    setError("");
    try {
      const invSnap = await getDocs(query(collection(db, "invitation")));
      const result = [];

      await Promise.all(
        invSnap.docs.map(async (invDoc) => {
          const alias = invDoc.data().familyAlias || invDoc.id;
          const guestSnap = await getDocs(
            query(collection(db, `invitation/${invDoc.id}/guess`))
          );
          guestSnap.docs.forEach((gDoc) => {
            const g = gDoc.data();
            if (g.confirmed) {
              result.push({ nombre: g.name || "", familia: alias, mesa: g.table || "—", tipo: "Principal" });
            }
            (g.wards || []).forEach((ward) => {
              if (ward.confirmed) {
                result.push({ nombre: ward.name || "", familia: alias, mesa: ward.table || g.table || "—", tipo: "Acompañante" });
              }
            });
          });
        })
      );

      result.sort((a, b) => {
        const mA = parseInt(a.mesa) || 9999;
        const mB = parseInt(b.mesa) || 9999;
        return mA !== mB ? mA - mB : a.nombre.localeCompare(b.nombre, "es");
      });

      setRows(result);
    } catch (err) {
      console.error("confirmados error", err);
      setError("Error al cargar los datos. Verifica tu conexión.");
    } finally {
      setLoading(false);
    }
  };

  const downloadCsv = () => {
    const header = ["Nombre", "Familia", "Mesa", "Tipo"];
    const lines = [
      header.join(","),
      ...rows.map((r) =>
        [r.nombre, r.familia, r.mesa, r.tipo]
          .map((v) => `"${String(v).replace(/"/g, '""')}"`)
          .join(",")
      ),
    ];
    const blob = new Blob(["﻿" + lines.join("\r\n")], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `confirmados_${new Date().toISOString().slice(0, 10)}.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const total = rows?.length ?? null;
  const mesas = rows
    ? [...new Set(rows.map((r) => r.mesa).filter((m) => m !== "—"))].length
    : null;

  return (
    <div className="admin-page">
      <div className="admin-section">
        <h3>Asistentes Confirmados</h3>
        <p>Carga la lista de confirmados cuando la necesites. El CSV se habilita después de cargar.</p>
      </div>

      <div className="conf-summary">
        <button
          type="button"
          className="btn-primary"
          onClick={fetchConfirmados}
          disabled={loading}
        >
          {loading ? "Cargando..." : rows !== null ? "Actualizar lista" : "Cargar confirmados"}
        </button>

        {total !== null && (
          <>
            <div className="conf-stat">
              <span className="conf-stat-num">{total}</span>
              <span className="conf-stat-label">Confirmados</span>
            </div>
            <div className="conf-stat">
              <span className="conf-stat-num">{mesas}</span>
              <span className="conf-stat-label">Mesas ocupadas</span>
            </div>
            <button
              type="button"
              className="btn-secondary"
              onClick={downloadCsv}
              disabled={total === 0}
            >
              Descargar CSV
            </button>
          </>
        )}
      </div>

      {error && <p className="status error">{error}</p>}

      {total === 0 && (
        <p className="status">Ningún invitado ha confirmado asistencia aún.</p>
      )}

      {rows && rows.length > 0 && (
        <div className="admin-form">
          <table className="conf-table">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Familia</th>
                <th>Mesa</th>
                <th>Tipo</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={i}>
                  <td>{r.nombre}</td>
                  <td>{r.familia}</td>
                  <td>{r.mesa}</td>
                  <td className={r.tipo === "Acompañante" ? "conf-ward" : ""}>{r.tipo}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ConfirmadosPage;
